import CreateBannerPage from "./create-banner.page";

export default CreateBannerPage;
